import React from "react";
import { ArrowLeft, Zap } from "lucide-react";
import { BOT_TYPES } from "./CampaignWizard.constants";

const WizardHeader = ({ selectedBotType, onCancel }) => {
  return (
    <div className="wizard-header">
      <button className="popup-cancel-btn" onClick={onCancel}>
        <ArrowLeft size={18} /> Back to Campaigns
      </button>
      <span className="wizard-title">
        <Zap size={18} />
        Create New {selectedBotType ? BOT_TYPES.find(b => b.id === selectedBotType)?.label : "Campaign"}
      </span>
      <div className="wizard-spacer"></div>
    </div>
  );
};

export default WizardHeader;
